// extracted by mini-css-extract-plugin
export default {"setInfo":"CompanyInfo_setInfo__ygE2Z","setDivLeft":"CompanyInfo_setDivLeft__tKH0+","setDivRight":"CompanyInfo_setDivRight__zzpCg","img":"CompanyInfo_img__cPJgA"};